import { ReactElement, useEffect, useState } from "react";
import { Card, Skeleton, Image, Typography, Row, Col, Button } from "antd";
import firebase from "firebase/app";
import moment from "moment";
import { HomeOutlined, AuditOutlined, FieldTimeOutlined, CarryOutOutlined, DeleteOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { capitalize } from "../utils/string";

const { Title } = Typography;

export default function BookingDetail({ book, onCancel }: any): ReactElement {

	const [loading, setLoading] = useState<boolean>(true);
	const [branch, setBranch] = useState<any>();
	const [club, setClub] = useState<any>();
	const [court, setCourt] = useState<any>();
	const [cancelable, setCancelable] = useState<boolean>(true);
	const { t } = useTranslation();

	useEffect(() => {
		async function getBookingDetails(branchId: string, courtId: string) {
			const branchSnapshot = await firebase.firestore().collection("branches").doc(branchId).get();
			const mBranch = branchSnapshot.data();
			const clubSnapshot = await firebase.firestore().collection("clubs").doc(mBranch?.club).get();
			const mClub = clubSnapshot.data();
			const courtSnapshot = await firebase.firestore().collection("courts").doc(courtId).get();
			const mCourt = courtSnapshot.data();
			setBranch(mBranch);
			setClub(mClub);
			setCourt(mCourt);
			setLoading(false);
		}
		const { branchId, courtId } = book;
		getBookingDetails(branchId, courtId);

		const today = moment();
		const bookedData = moment(`${book.date} ${book.start}`);
		if (today > bookedData) setCancelable(false);

	}, []);

	return (
		<Card style={{ borderRadius: 10, overflow: "hidden" }} bodyStyle={{ padding: loading ? 24 : 0 }}>
			<Skeleton loading={loading} active>
				{/* <Image 
						src={branch?.photo} height={150} width="100%" style={{ objectFit:"cover" }}
						fallback="data:image/png;base64,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"
				/> */}
				<div style={{ padding: 12 }}>
					<div>
						<Title level={5}>
							{club?.name}
							{cancelable &&
								<Button onClick={() => onCancel(book)} className="booking-remove-button">
									<DeleteOutlined style={{ fontSize: 16, color: "red" }} />
								</Button>}
						</Title>
					</div>
					<Row gutter={8}>
						<Col xs={24}>
							<CarryOutOutlined style={{ fontSize: 16 }} />
							<span style={{ marginLeft: 10, fontWeight: 400 }}>{moment(book.date).format("ddd, MMM DD, YYYY")}</span>
						</Col>
						<Col xs={24}>
							<HomeOutlined style={{ fontSize: 16 }} />
							<span style={{ marginLeft: 10 }}>{branch?.location}, {`${court?.name} (${capitalize(court?.place)})`}</span>
						</Col>
						<Col xs={24}>
							<FieldTimeOutlined style={{ fontSize: 16 }} />
							<span style={{ marginLeft: 10 }}>{moment(`${book.date} ${book.start}`).format("h:mm A")}~{moment(`${book.date} ${book.start}`).add(book.period, "m").format("h:mm A")}, {book.period} {t("mins")}</span>
						</Col>
						<Col xs={24}>
							<AuditOutlined style={{ fontSize: 16 }} />
							<span style={{ marginLeft: 10 }}>{book.price} {book.currency}</span>
							<span style={{ marginLeft: 5, fontSize: 12 }}>({book.paymentMethod === "online" ? "Online" : "Pay Over Count"})</span>
						</Col>
					</Row>
				</div>
			</Skeleton>
		</Card>
	)
}